import {Router} from "../router";

export class UrlSanitizer {


    public sanitize(router:Router, input, isRelative: boolean = true) {
        try {
            let url;

            if (isRelative)
                url = new URL(input, router.currentLocation()); // base to allow relative URLs
            else
                url = new URL(input); // base to allow relative URLs
            
            const protocol = url.protocol.toLowerCase();

            // Allow only safe protocols
            const allowedProtocols = ['http:', 'https:', 'mailto:'];

            if (allowedProtocols.includes(protocol)) {
                return url.href;
            }

            return ''; // Strip anything unsafe
        } catch (e) {
            // Invalid URL
            return '';
        }
    }

}